import styled from 'styled-components';

export const CenterNavUl = styled.ul`
    width: 250px;
    display: flex;
    text-align: center;
    padding-left: 0px;
    list-style-type: none;
`;

export const TabLi = styled.li`
    color: ${({ applicationMode, tab, enabled, theme }) => {
        if (enabled) {
            return tab === applicationMode ? theme.colors.primary300 : theme.colors.neutral900;
        }
        return theme.colors.neutral100;
    }};
    cursor: ${({ cursor }) => cursor};
    width: 110px;
    border-bottom: ${({ applicationMode, tab, theme }) => (applicationMode === tab ? `3px solid ${theme.colors.primary700}` : 'none')};

    &:hover {
        color:  ${({ enabled, theme }) => (enabled ? `${theme.colors.primary300} !important` : theme.neutral100)};
    }
`;

export const TabNameLink = styled.a`
    display: inline-block;
    font-size: 15px;
    font-weight: 600;
    width: 56px;
    margin: 8px 10px;
    line-height: 32px;
`;

export const TabTooltipDiv = styled.div`
    width: auto;
    text-align: left;
    padding: 0px;
`;
